import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import cx from 'classnames';

import appendQueryString from '../../utils/appendQueryString';
import { TRACKING_PAGEVIEW_SOURCE } from '../../../constants/tracking';

const ContentWrapper = styled.div``;

const DropDownWrapper = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: -2rem;
  padding-top: 10px;

  ${ContentWrapper}:hover & {
    display: block;
  }
`;

const DropDownContainer = styled.div.attrs({
  className: 'Card Card--dark'
})`
  width: 9rem; 
  padding: 18px;
`;

function PurchaseMenu(props) {
  return (
    <ContentWrapper className={cx('relative', props.className)} style={props.style}>
      <Link to={appendQueryString('/purchase/vip', { source: TRACKING_PAGEVIEW_SOURCE.NAVBAR })}>
        升級
      </Link>

      <DropDownWrapper>
        <DropDownContainer className="flex flex-col">
          <Link
            to={appendQueryString('/purchase/vip', { source: TRACKING_PAGEVIEW_SOURCE.NAVBAR })}
            className="self-start Btn Btn--text Btn--sm font-500"
          >
            VIP會員
          </Link>
          <Link
            to={appendQueryString('/purchase/package-group', { source: TRACKING_PAGEVIEW_SOURCE.NAVBAR })}
            className="self-start Btn Btn--text Btn--sm font-500"
          >
            主題訂閱
          </Link>
        </DropDownContainer>
      </DropDownWrapper>
    </ContentWrapper>
  );
}

export default PurchaseMenu;
